import IconChevronRight from '@apollo/icons/default/IconChevronRight.svg';
import {
  Breadcrumb as ChakraBreadcrumb,
  BreadcrumbProps as ChakraBreadcrumbProps,
  forwardRef,
} from '@chakra-ui/react';
import React from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';

export interface BreadcrumbProps
  extends OmitChakraProps<ChakraBreadcrumbProps, 'separator'> {
  separatorType?: 'chevron' | 'slash';
}

export const Breadcrumb = forwardRef<BreadcrumbProps, 'nav'>(
  ({ separatorType = 'chevron', ...props }, ref) => (
    <ChakraBreadcrumb
      {...props}
      ref={ref}
      separator={separatorType === 'chevron' ? <IconChevronRight /> : '/'}
    />
  ),
);
